/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

export { MoiraLambda } from "./lambda";
export { MoiraLambdaFactory } from "./lambdaFactory";
